import { ref, onMounted, onBeforeUnmount } from "vue";
import deviceInfo from "~/utils/device";

interface DeviceJudge {
  /** 是否移动端 */
  isMobile: boolean;
  /** 是否PC端 */
  isPC: boolean;
  /** 是否快影移动端 */
  isKyMobile: boolean;
  /** 是否为大屏尺寸 */
  isLargeScreen: boolean;
  isAndroid: boolean;
  isIOS: boolean;
  isKs: boolean;
  isSafari: boolean;
}

let device: DeviceJudge;

export default function useDevice(maxWidth = 1360) {
  if (!device) {
    device = reactive({
      isMobile: !deviceInfo.isPC,
      isPC: deviceInfo.isPC,
      isKyMobile: !deviceInfo.isPC && deviceInfo.isKy,
      isLargeScreen: window.innerWidth >= maxWidth,
      isAndroid: deviceInfo.isAndroid,
      isIOS: deviceInfo.isIOS,
      isKs: deviceInfo.isInKSJS || deviceInfo.isInKS,
      isSafari: navigator.userAgent.toLocaleLowerCase().indexOf("safari") > -1,
    });
  }

  const resize = () => {
    let width = window.innerWidth;
    if (width >= maxWidth) {
      device.isLargeScreen = true;
    } else {
      device.isLargeScreen = false;
    }
  };

  resize(); // 必须放外面，不能放在onMounted里面，让同步执行时添加属性监听，如果放在onMounted里面，会导致属性监听失效
  window.addEventListener("resize", resize, { passive: true });
  window.addEventListener("orientationchange", resize, { passive: true });
  onBeforeUnmount(() => {
    window.removeEventListener("resize", resize);
    window.removeEventListener("orientationchange", resize);
  });
  return toRefs(device);
}
